import { divergentColorScale, scaleLinear } from "@/lib/colorScale";
import data from "./data.json" with { type: "json" };

const maxCount = data.reduce((max: number, { count }) => Math.max(max, count), 0);

const color = scaleLinear([6500, 8000], divergentColorScale)

export function BarChart({ className }: { className?: string }) {
  const len = data.length;
  const barWidth = 1;
  const svgWidth = len * barWidth;
  const svgHeight = Math.round(maxCount * 1.3);
  const viewBox = `0 0 ${svgWidth} ${svgHeight}`;
  return (
    <svg className={className} viewBox={viewBox} preserveAspectRatio="none">
      {data.map(({ week, selling_price_per_meter, count }, index) => {
        return <rect
          key={week}
          x={index * barWidth}
          y={svgHeight - count}
          width={barWidth}
          height={count}
          fill={color(selling_price_per_meter)}
        />
      })}
    </svg>
  );
}
